








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class PendingPrescriptionStatusChip extends Vue {
  @Prop()
  public item: any;

  @Prop({ default: true })
  public small: boolean;
}
